import React, { useState} from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";

const LineGrid = ( { rows, columns}) => {

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20, // Only show 25 rows per page
  });
 

return (

        <Box sx={{
          height: "30vh", // Ensure parent container has height
          width: 900,
          border: "3px solid black",
        }}>
          
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id} 

            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel} // Enable pagination control
            pageSizeOptions={[10, 20]}
            rowCount={rows.length} // Ensure total row count is considered
            pageSize={10}
            columnHeaderHeight={30}
            getRowHeight={() => "auto"}
            localeText={{
              noRowsLabel: "No data available",
            }}
      
            sx={{

              "& .MuiDataGrid-root": { border: "1px solid black", }, // Outer border
              
              // ✅ Properly Target Header Background
              "& .MuiDataGrid-columnHeaders": { 
                backgroundColor: "#84817c", // Blue background
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "#84817c", // Ensures full coverage
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "white", // White text
                fontSize: "16px", // Larger text
                fontWeight: "bold", // Bold font
              },
    
              "& .MuiDataGrid-cell": { 
                borderBottom: "1px solid gray",
                fontSize: "16px"
                 }, 
                 
              // Row separators
              // "& .MuiDataGrid-row:nth-of-type(odd)": {
              //   backgroundColor: "#f5f5f5 !important", // Zebra striping for better readability
              // },

              "& .MuiDataGrid-row:nth-child(odd)": {
                backgroundColor: "#f5f5f5 !important", // ✅ Zebra striping
              },



              "& .MuiTablePagination-root": {
                  fontSize: "16px", // Doesn't always work alone
                },
                "& .MuiTablePagination-toolbar": {
                  fontSize: "16px", // ✅ Targets the entire pagination toolbar
                },
                "& .MuiTablePagination-caption": {
                  fontSize: "16px !important", // ✅ Text like "1–20 of 100"
                },
                "& .MuiSelect-select": {
                  fontSize: "16px", // ✅ Dropdown for rows per page (this worked for you)
                },
                "& .MuiTablePagination-displayedRows": {
                  fontSize: "16px !important", // ✅ Directly targets the page number text
                },
                "& .MuiTablePagination-selectLabel": {
                    fontSize: "16px", // ✅ Fix for "Rows per page:" text
                  },

                "& .MuiDataGrid-overlay": {
                    fontSize: "18px", // ✅ Change font size
                    fontFamily: "Arial, sans-serif", // ✅ Change font style
                    color: "grey", // Example: Change text color
                    fontWeight: "bold", // Example: Make it bold
                  },

                "& .MuiIconButton-root": {
                    width: "40px",  // Optional: Adjust button size
                    height: "40px", // Optional: Adjust button size
                  },
                  "& .MuiIconButton-root svg": {
                    fontSize: "30px", // ✅ Increase the icon size inside buttons
                  },                  

            }}
          />
          
        </Box>
)
}

export default LineGrid;